// @file Vuex plugin that listens/triggers changes in the address
import { MutationPayload, Store } from 'vuex'
import { RootState } from '../surface/types'

const history = window.history

export default (store: Store<RootState>): void => {
  const watchExpandedPost = (_mutation: MutationPayload, state: RootState): void => {
    if (!state.post.isInitialPaginatedDataLoadDone) return

    let newPathname = ''
    const getters = store.getters
    if (state.postAction.expandedPostCid) {
      newPathname = '/' + getters.address + '/wish/' + getters['postAction/expandedPostServerId']
      if (window.location.pathname !== newPathname) {
        history.pushState(
          {
            expandedPostCid: state.postAction.expandedPostCid,
            expandedPostServerId: getters['postAction/expandedPostServerId'],
          },
          '',
          newPathname,
        )
      }
    } else {
      if (state.isEmbedded) {
        newPathname = '/embed/' + getters.publicKey
      } else {
        newPathname = '/' + getters.address
      }
      if (window.location.pathname !== newPathname) {
        if (history.state && history.state.expandedPostServerId) {
          history.pushState({}, '', newPathname)
        } else {
          const oldPathname = window.location.pathname
          const pathSplited = oldPathname.split('/')
          const expandedPostServerId = pathSplited[pathSplited.length - 1]
          const expandedPostCid =
            store.getters['post/getPostByServerId'](expandedPostServerId)?.cid || `c${expandedPostServerId}`
          history.replaceState({ expandedPostCid, expandedPostServerId }, '', oldPathname)
          history.pushState({}, '', newPathname)
        }
      }
    }
  }
  let unsubscribeFromWatchingExpandedPost = store.subscribe(watchExpandedPost)

  window.addEventListener('popstate', (e) => {
    const eventState = e.state
    unsubscribeFromWatchingExpandedPost()
    if (eventState && eventState.expandedPostCid) {
      store.dispatch({
        type: 'postAction/expandPost',
        postCid: eventState.expandedPostCid,
        xTextPanel: true,
      })
    } else {
      store.dispatch({
        type: 'postAction/unexpandPost',
      })
    }
    unsubscribeFromWatchingExpandedPost = store.subscribe(watchExpandedPost)
  })
}
